//绘图方法
function textBecomeImg(text,fontsize,fontcolor){
  var canvas = document.createElement('canvas');
  let $buHeight = 0;
  if(fontsize <= 32){ $buHeight = 99; }
  else if(fontsize > 32 && fontsize <= 60 ){ $buHeight = 2;}
  else if(fontsize > 60 && fontsize <= 80 ){ $buHeight = 4;}
  else if(fontsize > 80 && fontsize <= 100 ){ $buHeight = 6;}
  else if(fontsize > 100 ){ $buHeight = 10;}
  canvas.height=fontsize + $buHeight ;
  canvas.padding=30;
  var context = canvas.getContext('2d');
  context.clearRect(0, 0, canvas.width*2, canvas.height);
  context.textAlign = "center";
  canvas.width = 200;
  canvas.height = 200;
  context.fillStyle = fontcolor;
  context.font=fontsize+"px Arial";
  context.textBaseline = 'middle';
  context.fillText(text,0,fontsize/2);
  // var canvasWidth = canvas.widt / 99;
  // canvasWidth = context.measureText(text).width;
  var dataUrl = canvas.toDataURL('image/png');
  return dataUrl;
}

export function addWaterMark(text, fontsize=14, fontcolor="#000"){
  // var text = (new Date().getTime())+'test';
	var shuiyinDiv = document.createElement('div');
	var style = shuiyinDiv.style;
	style.position = 'fixed';
	style.left = 0;
	style.top = '-60%';
	style.width = '120%';
	style.height = '200%';
	style.opacity = '0.05';//透明度
	style.background = "url("+textBecomeImg(text, fontsize, fontcolor)+")";
	style.zIndex = 9999999991;//置顶
	style.transform = "rotate(-15deg)";
	style.pointerEvents = "none";//不影响鼠标事件
	document.body.appendChild(shuiyinDiv);

}
